export default "__VITE_ASSET__DPbW4Hxn__"